import { create } from "zustand";
export type PageKind = "results";
export interface WorkspacePage { id: string; title: string; kind: PageKind; }
interface S { pages: WorkspacePage[]; activeId: string|null;
  open:(p:WorkspacePage)=>void; close:(id:string)=>void; activate:(id:string)=>void;
  rename:(id:string,title:string)=>void; reset:()=>void; }
export const usePagesStore = create<S>((set) => ({
  pages:[], activeId:null,
  open:  (page)=>set((s)=>({ pages:s.pages.some(p=>p.id===page.id)?s.pages:[...s.pages,page], activeId:page.id })),
  close: (id)=>set((s)=>{
    const idx=s.pages.findIndex(p=>p.id===id), pages=s.pages.filter(p=>p.id!==id);
    return { pages, activeId:s.activeId===id?(pages[idx]?.id??pages[idx-1]?.id??null):s.activeId };
  }),
  activate:(id)=>set({activeId:id}),
  rename:(id,title)=>set((s)=>({pages:s.pages.map(p=>p.id===id?{...p,title}:p)})),
  reset:()=>set({pages:[],activeId:null}),
}));
